import React from 'react';
import axios from './../../../../constants/axios';
import { Button, Col, Row, Table } from 'react-bootstrap';
import { Link } from 'react-router';
import moment from 'moment';
import DatePicker from 'react-datepicker';

class ContactSaleReturnInvoice extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         invoices: [],
         showOnlyDue: false,
      };
   }

   componentDidMount() {
      const { contactId } = this.props.params;
      axios.get('contacts/' + contactId + '/saleReturnInvoices')
         .then((res) => {
            this.setState({
               invoices: res.data.results,
               startDate: moment(res.data.startDate),
               endDate: moment(res.data.endDate),
            });
         });
   }

   handleStartDateChange = (date) => {
      this.setState({
         startDate: date
      });
   };

   handleEndDateChange = (date) => {
      this.setState({
         endDate: date
      });
   };

   getInvoicesDateBetween = () => {
      const { startDate, endDate } = this.state;
      const { contactId } = this.props.params;

      if (startDate && endDate) {
         axios.get(`contacts/${contactId}/saleReturnInvoices?startDate=${startDate.format('YYYY-MM-DD')}&endDate=${endDate.format('YYYY-MM-DD')}`)
            .then((res) => {
               this.setState({
                  invoices: res.data.results,
                  startDate: moment(res.data.startDate),
                  endDate: moment(res.data.endDate),
               });
            });
      }
   };

   showOnlyDue = (e) => {
      const value = e.target.checked;
      this.setState({
         showOnlyDue: value,
         invoices: [],
      });
      if (value === true) {
         const { contactId } = this.props.params;
         axios.get(`contacts/${contactId}/saleReturnDueInvoices`)
            .then((res) => {
               this.setState({
                  invoices: res.data,
               });
            });
      } else {
         this.getInvoicesDateBetween();
      }
   };

   render() {
      const { invoices, showOnlyDue } = this.state;
      return (
         <div className="ContactSaleReturnInvoice" >
            <Row >
               <Col md={6} >
                  {showOnlyDue === false &&
                  <div >
                     <DatePicker
                        dateFormat="DD-MM-YYYY"
                        selected={this.state.startDate}
                        placeholderText="Select Start Date"
                        onChange={this.handleStartDateChange} />
                     <DatePicker
                        dateFormat="DD-MM-YYYY"
                        selected={this.state.endDate}
                        placeholderText="Select End Date"
                        onChange={this.handleEndDateChange} />
                     <Button onClick={() => this.getInvoicesDateBetween()} >Get Invoices</Button >
                  </div >
                  }
               </Col >
               <Col md={6} >
                  <input type="checkbox" id="showOnlyDue" name="showOnlyDue" checked={this.state.showOnlyDue}
                         onChange={(e) => this.showOnlyDue(e)} />
                  <label htmlFor="showOnlyDue" >Show Only Due</label >
               </Col >
            </Row >

            <Table >
               <thead >
               <tr >
                  <th >#inv Id</th >
                  <th >Billed</th >
                  <th >Paid Amount</th >
                  <th >Due</th >
                  <th >Inv Created</th >
                  <th >##</th >
               </tr >
               </thead >
               <tbody >
               {invoices.map((sale) => (
                  <tr key={sale.id} >
                     <td >{sale.id}</td >
                     <td >{sale.total_amount}</td >
                     <td >{sale.paid_amount}</td >
                     <td >{sale.due}</td >
                     <td >{moment(sale.created_at).format('DD/MM/YYYY h:mm a')}</td >
                     <td ><Link to={`/sale/saleInvoiceDetail/${sale.id}`} >Details</Link >
                        {sale.due !== 0 &&
                        <Link to={`/sale/saleReceivePayment/${sale.id}`} >Receive Payment</Link >
                        }
                     </td >
                  </tr >
               ))}
               </tbody >
            </Table >
         </div >
      );
   }
}

ContactSaleReturnInvoice.propTypes = {
   params: React.PropTypes.object,
};

export default ContactSaleReturnInvoice;



/** WEBPACK FOOTER **
 ** ./src/components/Contact/ContactDetail/ContactInvoice/SaleReturnInvoice.js
 **/